import { Navbar } from '@/components/layout/Navbar';
import { Sidebar } from '@/components/layout/Sidebar';
import { CommandPalette } from '@/components/ui/CommandPalette';
import { useUI } from '@/lib/uiContext';
import { useAuth0 } from '@auth0/auth0-react';
import * as React from 'react';
import { useLocation } from 'react-router-dom';

export const DashboardLayout: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const { user, isLoading, loginWithRedirect } = useAuth0();
  const { commandPaletteOpen, closeCommandPalette } = useUI();
  const location = useLocation();

  // Redirect to login if not authenticated, preserving the current URL
  React.useEffect(() => {
    if (!isLoading && !user) {
      loginWithRedirect({
        appState: {
          returnTo: location.pathname + location.search,
        },
      });
    }
  }, [user, isLoading, loginWithRedirect, location.pathname, location.search]);

  if (isLoading) {
    return (
      <div className='flex items-center justify-center min-h-screen bg-grey-50'>
        <div className='max-w-md w-full mx-auto p-6'>
          <div className='bg-white rounded-lg shadow-lg p-8'>
            <div className='text-center'>
              <div className='animate-pulse'>
                <div className='rounded-full h-16 w-16 bg-grey-200 mx-auto mb-4'></div>
                <div className='h-4 bg-grey-200 rounded w-3/4 mx-auto mb-2'></div>
                <div className='h-3 bg-grey-200 rounded w-1/2 mx-auto'></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!user) {
    return null;
  }

  return (
    <div className='min-h-screen'>
      <Sidebar />
      <div className='ml-0 lg:ml-64 min-h-screen bg-grey-50 transition-all duration-300'>
        <Navbar />
        <main className='p-8 max-w-7xl mx-auto'>{children}</main>
      </div>

      {/* Command Palette */}
      <CommandPalette
        isOpen={commandPaletteOpen}
        onClose={closeCommandPalette}
      />
    </div>
  );
};
